// extracted by mini-css-extract-plugin
export var descriptionCard = "Card-module--descriptionCard--k1mv-";
export var image = "Card-module--image---PGbX";